import { render, staticRenderFns } from "./Manage-All-Certificates-TypeWise.vue?vue&type=template&id=e54799d0"
import script from "./Manage-All-Certificates-TypeWise.vue?vue&type=script&lang=js"
export * from "./Manage-All-Certificates-TypeWise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports